import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, {} from 'react';
import dayjs from "dayjs";
import ActiveStatusTag from "./ActiveStatusTag";
import { DateTimeFormat } from "./FormattersTS";
const ActiveAtStatusTag = ({ inactiveAt, prefix = "Disabled" }) => {
    const isActive = !inactiveAt || dayjs().isBefore(dayjs(inactiveAt));
    let inactiveMessage = '';
    if (inactiveAt) {
        if (dayjs(inactiveAt).isAfter(dayjs())) {
            inactiveMessage = prefix + ' from ';
        }
        else {
            inactiveMessage = prefix + ' since ';
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx(ActiveStatusTag, { active: isActive }), (!isActive || inactiveMessage) ?
                _jsxs(_Fragment, { children: [_jsx("br", {}), inactiveMessage, _jsx("br", {}), _jsx(DateTimeFormat, { value: inactiveAt })] })
                : null] }));
};
export default ActiveAtStatusTag;
